import { HomepageHeroProps } from './types';
import { HomepageHeroVariants } from './constants';
import HomepageHeroCenteredVariant from './HomepageHeroCenteredVariant';
import HomepageHeroTwoColumnVariant from './HomepageHeroTwoColumnVariant';

const HomepageHero = (props: HomepageHeroProps) => {
  const { variant } = props;

  switch (variant) {
    case HomepageHeroVariants.Centered:
      return <HomepageHeroCenteredVariant {...props} />;
    case HomepageHeroVariants.TwoColumn:
      return <HomepageHeroTwoColumnVariant {...props} />;
    default:
      return null;
  }
};

export default HomepageHero;
